import React from 'react';
import { useHistoryOverride } from '../../context/HistoryOverrideContext';
import CarCardWrapper from '../CarCard/CarCardWrapper';

const HistoryDrawer: React.FC = () => {
  const {
    overrideResults,
    overrideHash,
    overrideTitle,
    isLoading,
    setOverrideResults,
    setOverrideHash,
    setOverrideTitle,
  } = useHistoryOverride();

  const isOpen = isLoading || (overrideResults !== null);

  if (!isOpen) return null;

  const handleClose = () => {
    setOverrideResults(null);
    setOverrideHash(null);
    setOverrideTitle(null);
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleClose}
      />

      {/* Drawer panel */}
      <div className="relative w-full max-w-2xl h-full bg-mp-bg border-l border-mp-border flex flex-col overflow-hidden">
        {/* Drawer header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-mp-border shrink-0">
          <div className="flex flex-col gap-0.5">
            <h2 className="font-display text-sm uppercase tracking-widest text-mp-text">
              Full Listing History
            </h2>
            {overrideTitle && (
              <p className="font-mono text-xs text-mp-muted">{overrideTitle}</p>
            )}
          </div>
          <div className="flex items-center gap-4">
            {overrideResults && (
              <span className="font-mono text-xs text-mp-accent border border-mp-border px-2 py-1 bg-mp-surface">
                {overrideResults.length} UNIQUE CAR{overrideResults.length !== 1 ? 'S' : ''} · 24M
              </span>
            )}
            <button
              onClick={handleClose}
              className="text-mp-muted hover:text-mp-text transition-colors"
              aria-label="Close history drawer"
            >
              <span className="material-symbols-outlined text-xl">close</span>
            </button>
          </div>
        </div>

        {/* Drawer body */}
        <div className="flex-1 overflow-y-auto px-6 py-6 flex flex-col gap-4">
          {isLoading && (
            <p className="font-mono text-mp-muted text-sm animate-pulse text-center py-12">
              &gt; LOADING HISTORY...
            </p>
          )}

          {!isLoading && overrideResults && overrideResults.length === 0 && (
            <p className="font-mono text-mp-muted text-sm text-center py-12">
              &gt; No records found
            </p>
          )}

          {!isLoading && overrideResults && overrideResults.map((result, i) => (
            <CarCardWrapper key={i} result={result} />
          ))}
        </div>

        {/* Footer note */}
        {overrideResults && overrideResults.length > 0 && (
          <div className="px-6 py-3 border-t border-mp-border shrink-0">
            <p className="font-mono text-[10px] text-mp-muted">
              Showing deduplicated listings from both current and historic indices. 
              Sidebar filters apply to the search results behind this panel.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryDrawer;  